import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

interface RequireTokenProps {
  children: React.ReactElement;
}

const RequireToken: React.FC<RequireTokenProps> = ({ children }) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireToken;
